module.exports = [{"key":"0","text":"Nei"},{"key":"5","text":"Ja"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/fasttrack.json
// module id = 1108
// module chunks = 0